module.exports = __webpack_public_path__ + "media/images/temp/ribbon-3-ac03843ae252afe29af77fa8e717fa55.png";